<!--
 * @Author:
 * @LastEditTime: 2024-05-06 15:04:51
 * @Description:
-->
<template>
  <div class="h-full w-full cockpit origin-center">
    <visualizationCockpit
      v-if="modelSetting.cloudRenderVersion === 4"
      :mode="mode"
      @toggleMode="toggleMode"
    />
    <visualizationCockpitVulkan v-else :mode="mode" @toggleMode="toggleMode" />
    <left-com v-if="mode === 'cockpit'"></left-com>
    <right-com v-if="mode === 'cockpit'"></right-com>
    <middle-com v-if="mode === 'cockpit'"></middle-com>
  </div>
</template>

<script>
import visualizationCockpit from '@/modules/visualization-cockpit/views/index'
import visualizationCockpitVulkan from '@/modules/visualization-cockpit-vulkan/views/index'
import LeftCom from '../components/leftCom/index'
import RightCom from '../components/rightCom/index'
import MiddleCom from '../components/middleCom/index'

export default {
  components: {
    visualizationCockpit,
    visualizationCockpitVulkan,
    LeftCom,
    RightCom,
    MiddleCom,
  },
  data() {
    return {
      mode: 'cockpit',
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  methods: {
    toggleMode() {
      this.mode = this.mode === 'cockpit' ? 'visualization' : 'cockpit'
    },
  },
  created() {},
}
</script>

<style scoped lang="scss"></style>
